export default __webpack_public_path__ + "static/media/utilities.77176f30.svg";